import Vue from 'vue'

/**
 * @author Jose Luis R
 * Comprehensive Privacy Notice
 */

export default () =>
  Vue.$http.put(`/users/current/policy_whatsapp_business/`)
    .then((res) => res.data)
